import {useDeploymentAccountGroupsQuery} from './useDeploymentAccountGroupsQuery';
import {useDeploymentAccountGroupsSearch} from './useDeploymentAccountGroupsSearch';

export const useDeploymentAccountGroups = () => {
    const {data: items = [], isLoading: loading} = useDeploymentAccountGroupsQuery();
    const {keyword} = useDeploymentAccountGroupsSearch();

    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
    };
};
